module.exports = __webpack_public_path__ + "df55c82d3c56be04228fa547d80e14df.pdf";